import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form } from "reactstrap";
import useRequests from '../../../Utils/useRequests';

const DeleteSpecialEquipment = ({ item, onClose }) => {
  const { postRequest } = useRequests();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await postRequest('delete-special-equipment', JSON.stringify({ se_id: item.se_id }));
    setLoading(false);
    onClose(res && res.code === 200 ? 'success' : 'error', res.message);
  };

  return (
    <Modal isOpen toggle={() => onClose()}>
      <ModalHeader toggle={() => onClose()}>
        Delete Special Equipment
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          Are you sure you want to delete this item and all its sub-items?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? "Deleting..." : "Yes, Delete"}
          </Button>
          <Button color="secondary" onClick={() => onClose()}>Cancel</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default DeleteSpecialEquipment;